import DateIntervalParser from "./dateModels/DateIntervalParser.ts";
import moment = require("moment");

export default class DateFormatter {
    /**
     * @param value
     */
    format(value: any) {
        if (null === value || null === value.startDate || null === value.endDate) {
            return {
                startDate: null,
                endDate: null
            };
        }

        let dateIntervalParser = new DateIntervalParser();
        let dateStartInterval = dateIntervalParser.execute(value.startDate);
        let startDate = moment(dateStartInterval.getDate()).format('YYYY-MM-DD');
        let dateEndIntervalEnd = dateIntervalParser.execute(value.endDate);
        let endDate = moment(dateEndIntervalEnd.getDate()).format('YYYY-MM-DD');

        return {
            startDate: startDate,
            endDate: endDate
        };
    }
}


// WEBPACK FOOTER //
// ./src/Models/DateFormatter.ts